module.exports = __webpack_public_path__ + "static/media/your_kirana.f5d27e00.png";